

<div class="order-component-container page-root-container">
    <div class="page-header">
        <div class="page-title">
            <img   src="assets/images/menu/svg/reports.svg">   <div class="title">
                &nbsp;&nbsp;Orders
              </div>    
            </div>
        <div class="page-actions"></div>
    </div>

    <div class="data-container">
        <app-loader [show]="isLoading"></app-loader>

        <app-search-filter #searchFilter [pagingData]="pagingData" [pageSizeOptions]="[5, 10, 20, 50, 100]"
            [filter]="filter" (page)="onePageEvent($event)" (onApply)="onFilterApplied($event)" [hidePageSize]="true">
        </app-search-filter>

        <section tabindex="0" class="table-container">
            <table matSort mat-table [dataSource]="dataSource">
                <ng-container matColumnDef="item">
                    <th mat-header-cell *matHeaderCellDef (click)="sortData($event)" class="item-header">
                        #
                    </th>
                    <td mat-cell *matCellDef="let order; let i = index" class="item-column">
                        {{ pagingData.pageIndex * pagingData.pageSize + i + 1 }}
                    </td>
                </ng-container>
                (matSortChange)="sortData($event)">
         
                <ng-container matColumnDef="order_id">
                    <th mat-sort-header="order_hdrs.order_id" mat-header-cell *matHeaderCellDef
                            (click)="sortData($event)"> Order Id </th>
                    <td mat-cell *matCellDef="let order"> {{ order.order_id }}
                    </td>
            </ng-container>

                <ng-container matColumnDef="station_code">
                    <th mat-sort-header="station_code" mat-header-cell *matHeaderCellDef (click)="sortData($event)">
                        Station
                    </th>
                    <td mat-cell *matCellDef="let order">{{ order.station_code }}</td>
                </ng-container>
                <ng-container matColumnDef="user_name">
                    <th mat-sort-header="users.name" mat-header-cell *matHeaderCellDef (click)="sortData($event)">
                        User
                    </th>
                    <td mat-cell *matCellDef="let order">
                        {{ order.user_name }}
                    </td>
                </ng-container>
                <ng-container matColumnDef="closing_time">
                    <th mat-sort-header="closing_time" mat-header-cell *matHeaderCellDef (click)="sortData($event)">
                        Order Time
                    </th>
                    <td mat-cell *matCellDef="let order">
                        {{ order.closing_time |  date: dateFormat}}
                    </td>
                </ng-container>
                <ng-container matColumnDef="closing_date">
                    <th mat-sort-header="closing_date" mat-header-cell *matHeaderCellDef (click)="sortData($event)">
                        POS Date
                    </th>
                    <td mat-cell *matCellDef="let order">
                        {{ order.closing_date | date: 'dd-MM-yyyy' }}

                    </td>
                </ng-container>
                <ng-container matColumnDef="customer">
                    <th mat-sort-header="order_customer.first_name" mat-header-cell (click)="sortData($event)"
                            *matHeaderCellDef>Customer
                    </th>
                    <td mat-cell *matCellDef="let order" style="min-width:100px;">
                            <div class="col-customer">
                                <span class="cust-name">{{order.customer}}</span>
                                <span class="cust-email">{{order.email }}</span>
                                
                            </div>
                        </td>
                  
            </ng-container>
            <ng-container matColumnDef="status">
                <th mat-sort-header="status" mat-header-cell (click)="sortData($event)"
                        *matHeaderCellDef>Status
                </th>
                <td mat-cell *matCellDef="let order" style="min-width:100px;">
                        <div [ngClass]="{ 'closed': order.status === 3, 'refunded': order.status === 4 }">
                            {{order.status_text}}
                            
                        </div>
                    </td>
              
        </ng-container>
             
                <ng-container matColumnDef="total_amount_paid">
                    <th mat-sort-header="total_amount_paid" mat-header-cell *matHeaderCellDef class="header" (click)="sortData($event)">
                        Total
                    </th>
                    <td mat-cell *matCellDef="let order" class="amount">{{(order.final_amount ?? 0 | currency: 'USD' : 'symbol' : '1.2-2') }}
                    </td>
                  </ng-container>
                <ng-container matColumnDef="action" stickyEnd>
                    <th mat-header-cell *matHeaderCellDef></th>
                    <td mat-cell class="row-menu-btn" style="width: 50px" *matCellDef="let order">
                        <a mat-icon-button class="row-menu-btn" [matMenuTriggerFor]="rowMenu"
                            (click)="onRowSelected(order); $event.stopPropagation()">
                            <mat-icon>more_vert</mat-icon>
                        </a>

                        <mat-menu #rowMenu>
                            <button mat-menu-item (click)="onRedirect(order)">View</button>
                            <button mat-menu-item (click)="openEmailDialog()">Mail</button>


                        </mat-menu>
                    </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
                <tr mat-row class="table-element-row" *matRowDef="let order; columns: displayedColumns"
                    (click)="onRowSelected(order)" (dblclick)="onRedirect(order)"
                    [ngClass]="{ 'row-selected': order.order_id === selectedItem?.order_id }"></tr>
            </table>
        </section>

        <!-- </ng-container> -->
        <!-- <ng-template #nodata> -->
        @if(pagingData.length<=0){ <div class="no-data-container">
            <img src="assets/images/no-data.png" />
            <span class="no-data-info">No data found. Please remove or redefine the filters if any.</span>
    </div>
    <!-- </ng-template> -->
    }
</div>
</div>